<template>
  <div class="reportTable">
    <section ref="print">
      <div class="title">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.startDate).format("YYYY-MM-DD") }}</span>
            <span
              v-if="$parent.endTimeShow"
            >至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <div class="form-content">
          <div class="formTitle">
            <span style="width: 100px">账号</span>
            <span style="width: 170px">订单号</span>
            <span style="width:60px">姓名</span>
            <span style="width:30px">性别</span>
            <span style="width:90px">客房类型</span>
            <span style="width:30px">间数</span>
            <span style="width:60px">房间号</span>
            <span style="width:65px;text-align:right">房价</span>
            <span style="width:130px">抵店时间</span>
            <span style="width: 90px">预离时间</span>
            <span style="width:60px">操作员</span>
            <span style="text-align:left;padding-left:10px;flex:1">协议单位/备注</span>
          </div>
        </div>
        <div class="formContaniner">
          <transition-group name="listOfForms" tag="p">
            <div class="PreArrivalItem" v-for="(item, index) in preArrivalList" v-bind:key="index">
              <div style="width: 100px">{{ item.accNo }}</div>
              <div style="width: 170px">{{ item.reseNo }}</div>
              <div style="width:60px">{{ item.guestName }}</div>
              <div style="width:30px">{{ item.sex ? "男" : "女" }}</div>
              <div style="width:90px">{{ item.roomTypeName }}</div>
              <div style="width:30px">{{ item.roomNum }}</div>
              <div style="width:60px">{{ item.roomName }}</div>
              <div style="width:65px;text-align:right">{{ curreny(item.price) }}</div>
              <div style="width:130px">{{ item.arrivalDate }} {{ item.arrivalTime }}</div>
              <div style="width: 90px">{{ item.departure }}</div>
              <div style="width:60px">{{ item.name }}</div>
              <div style="text-align:left;padding-left:10px;flex:1">
                {{ item.custname
                }}
                <span v-if="item.custname && item.remark">/</span>
                {{ item.remark }}
              </div>
            </div>
          </transition-group>
        </div>

        <div class="formTitle" style="border:none;font-weight:bold">
          <span style="width: 100px"></span>
          <span style="width: 170px"></span>
          <span style="width:60px">合计</span>
          <span style="width:30px"></span>
          <span style="width:90px">{{ record }}条记录</span>
          <span style="width:30px"></span>
          <span style="width:60px">{{ room }}间</span>
          <span style="width:65px;text-align:right">{{ curreny(total) }}</span>
          <span style="width:130px"></span>
          <span style="width: 90px"></span>
          <span style="width:60px"></span>
          <span style="flex:1"></span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    // const self = this;
    return {
      preArrivalList: [],
      // 记录
      record: 0,
      room: 0,
      total: 0,
      allPage: 0,
      userName: localStorage.getItem("cname"),
      // hotelMsg: self.$store.state.hotelInfo
      queryDate: "",
      date: "",
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "F03.本日已经登记宾客";
    this.getPreArrivalList();
    this.queryDate = new Date();
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.closeshow();
    this.$parent.chaxunvib = true;
  },
  methods: {
    doserach(){
      this.getPreArrivalList();
    },
    curreny(data) {
      if (data == 0) {
        return "0.00";
      } else if (data) {
        data = Number(data).toFixed(2);
        return data;
      }
    },
    dodayin() {
      this.$print(this.$refs.print);
    },
    dateChange(data) {
      // 
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    getPreArrivalList() {
       this.total = 0;
      this.room = 0;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/reportForFront/selectTodayRegister").then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.$parent.datacount = res.data.length;
          this.preArrivalList = res.data;
          this.$store.state.preArrivalList = res.data;
          this.$store.state.preArrivalName = "F03.本日已经登记宾客";
          this.record = res.data.length;
          this.allPage = Math.ceil(res.data.length / 10);
          this.preArrivalList.forEach(item => {
            // this.room += item.roomNum;
            this.total += item.price;
          });
          var arr = [];
          arr = this.preArrivalList.filter(
            (item, index, origin) =>
              index ===
              origin.findIndex(itemInner => {
                return itemInner.roomName === item.roomName;
              })
          );
          this.room += arr.length;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          vm.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.reportTable {
  /* padding: 1em; */
  height: 100%;
  /* overflow: scroll; */
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1em;
  height: 92px;
}
.title > ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li {
  list-style: none;
  font-size: 14px;
}
.title-label {
  font-size: 14px;
  margin-bottom: 1em;
}

.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 8%;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 8%;
  text-align: center;
  border: 1px solid #000;
}
.queryDate {
  position: relative;
  top: 0px;
  width: 100%;
  height: 3em;
  line-height: 3em;
  background-color: #e7f0ff;
}
.queryDate > span {
  margin: 15px;
}
.el-input {
  background-color: transparent;
}
.report {
  /* margin-bottom: 80px; */
  overflow: scroll;
}
</style>
